const styles = (theme) => ({
  radioGroupLabel: {
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    color: theme.popupLeftColColor,
  },
  radioLabel: {
    paddingRight: 32,
    marginBottom: 6,
    backgroundColor: "#EAF6F5",
    marginLeft: 0,
    marginRight: 8,
    borderRadius: 32,
  },
  checkboxLabel: {
    paddingRight: 32,
    marginBottom: 6,
    backgroundColor: "#EAF6F5",
    marginLeft: 0,
    marginRight: 8,
  },
  radioLabelText: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: "#227270",
  },
  checkBox: {
    color: "#7EC3C1",
  },
  multiLineInputField: {
    color: theme.TextColor,
  },
  inputFieldLabel: {
    color: theme.TextColor,
    opacity: 0.6,
  },
  limitedAccessList: {
    top: 24,
    width: "100%",
  },
  limitedAccessFormControl: {
    width: "100%",
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "space-between",
    padding: 16,
  },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  fullWidth: { width: "100%" },
  fieldRoot: {},
  label: {
    color: theme.TextColor,
    transform: "translate(14px, 14px) scale(1)",
    fontSize: theme.headerTextFontSize,
    opacity: 0.7,
  },
  notchedOutline: {},
  inputRoot: {
    "& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline":
      {
        borderColor: `${theme.iconColor}`,
      },
  },
  inputFocused: {},
  inputDisabled: {},
  inputError: {},
  inputField: {
    padding: 12,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: "initial",
  },
  iconClass: {
    color: theme.iconColor,
    cursor: "pointer",
  },
  disabled:{
    backgroundColor: theme.headerIconColor,
    cursor:"not-allowed"
  }
});

export default styles;